<div class="p-4 py rounded-md border-l-4 border-primary-400 bg-base drop-shadow-lg text-center">
  <a [routerLink]="backLink$ | async" style="cursor: pointer; display: inline-block"
    ><img class="max-h-24" src="{{ portalSvc.config.logo }}"
  /></a>
  <ng-container *ngIf="!portalSvc.config.logoOnly">
    <h3 class="text-xl font-bold">{{ portalSvc.config.brandName }} - {{ portalSvc.config.productName }}</h3>
    <p>{{ portalSvc.config.tagLine }}</p>
  </ng-container>
</div>
